<template>
    <div class="loader" v-show="show">
        <div class="loader-inner">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                    viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                <path fill="#fff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                    <animateTransform
                            attributeName="transform"
                            attributeType="XML"
                            type="rotate"
                            dur="1s"
                            from="0 50 50"
                            to="360 50 50"
                            repeatCount="indefinite" />
                </path>
            </svg>
        </div>
        <div class="loading-msg">{{message}}</div>
        <div class="mask"></div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: "加载中..."
    };
  }
};
</script>

<style lang="less" scoped>
.loader {
    background: #000;
    overflow: hidden;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 99999;
    height: 100px;
    width: 100px;
    margin-top: -50px;
    margin-left: -50px;
    opacity: .85;
    border-radius: 2vw;
}

.loading-msg{
    color: white;
    font-size: 14px;
    text-align: center;
    line-height: 1em;
    width: 100%;
    margin-top: 0px;
}

.loader-inner {
    height: 70px;
    margin: 1vw auto 0vw;
    width: 100px;
    text-align: center;

    svg{
        width: 60px;
    }
}

.mask{
    background: transparent;
}


</style>


// WEBPACK FOOTER //
// src/components/global/loading/loading.vue